module.exports = __webpack_public_path__ + "img/a272973.png";